/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientProgramModel } from '../../models/patient-program-model';

export interface GetPatientProgramContent$Params {
  programID?: number;
}

export function GetPatientProgramContent(http: HttpClient, rootUrl: string, params?: GetPatientProgramContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientProgramContent.PATH, 'get');
  if (params) {
    rb.query('programID', params.programID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientProgramModel>;
    })
  );
}

GetPatientProgramContent.PATH = '/api/Supervisor/GetPatientProgramContent';
